import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59e3f816"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cart-view__section-title" }, " Оформление заказа ", -1))
const _hoisted_3 = {
  key: 0,
  class: "cart-view__cooking-time-warning"
}
const _hoisted_4 = { class: "cart-view__products products" }
const _hoisted_5 = {
  id: "userCustomer",
  class: "cart-view__section-title customer-title"
}
const _hoisted_6 = {
  key: 0,
  class: "title-error"
}
const _hoisted_7 = { class: "cart-view__user-customers" }
const _hoisted_8 = {
  id: "deliveryTypeId",
  class: "cart-view__section-title delivery-type-title"
}
const _hoisted_9 = {
  key: 0,
  class: "title-error"
}
const _hoisted_10 = { class: "cart-view__delivery-types" }
const _hoisted_11 = {
  key: 0,
  class: "cart-view__delivery-adresses"
}
const _hoisted_12 = {
  id: "companyUserDeliveryAddress",
  class: "cart-view__section-title"
}
const _hoisted_13 = {
  key: 0,
  class: "title-error"
}
const _hoisted_14 = {
  key: 1,
  class: "cart-view__pickups"
}
const _hoisted_15 = {
  id: "companyPickupAddress",
  class: "cart-view__section-title"
}
const _hoisted_16 = {
  key: 0,
  class: "title-error"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cart-view__section-title additional-info-title" }, " Дополнительная информация ", -1))
const _hoisted_18 = { class: "cart-view__delivery-settings-form" }
const _hoisted_19 = {
  id: "paymentTypeId",
  class: "cart-view__section-title payment-type-title"
}
const _hoisted_20 = {
  key: 0,
  class: "title-error"
}
const _hoisted_21 = { class: "cart-view__payment-types" }
const _hoisted_22 = {
  key: 1,
  class: "cart-view__after-payment-type-form"
}
const _hoisted_23 = { class: "mo-form-group mo-form-group--cash-amount mo-form-group--line" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "С какой суммы подготовить сдачу?", -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 2,
  class: "cart-view__after-payment-type-form"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email для отправки электронного чека", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "mo-form-group__error error"
}
const _hoisted_30 = { class: "cart-view__legal-info" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Пожалуйста, обратите внимание: стоимость заказа может незначительно отличаться от указанной на сайте. ", -1))
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductsPanel = _resolveComponent("ProductsPanel")!
  const _component_UserCustomersList = _resolveComponent("UserCustomersList")!
  const _component_DeliveryTypesPanel = _resolveComponent("DeliveryTypesPanel")!
  const _component_DeliveryAddressesList = _resolveComponent("DeliveryAddressesList")!
  const _component_PickupAddresses = _resolveComponent("PickupAddresses")!
  const _component_DeliverySettingsForm = _resolveComponent("DeliverySettingsForm")!
  const _component_PaymentTypesPanel = _resolveComponent("PaymentTypesPanel")!
  const _component_CertificateWarning = _resolveComponent("CertificateWarning")!
  const _component_SummaryLayout = _resolveComponent("SummaryLayout")!
  const _component_EmptyLayout = _resolveComponent("EmptyLayout")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.orderStore.activeOrder?.items?.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("section", null, [
            _hoisted_2,
            (_ctx.orderStore.cookingTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " В корзине есть товары по предзаказу, получение заказа с " + _toDisplayString(_ctx.orderStore.getCookingDateString(_ctx.orderStore.cookingTime)) + ". Для скорейшей доставки прочих позиций закажите товар по предзаказу отдельно. ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ProductsPanel, {
                "order-items": _ctx.orderStore.activeOrder.items,
                onIncreaseItemQuantity: _ctx.orderStore.increaseItemQuantity,
                onDecreaseItemQuantity: _ctx.orderStore.decreaseItemQuantity,
                onDeleteItem: _ctx.orderStore.deleteItem
              }, null, 8, ["order-items", "onIncreaseItemQuantity", "onDecreaseItemQuantity", "onDeleteItem"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(" Получатель "),
              (
              _ctx.orderStore.processBtnWasClicked &&
                _ctx.orderStore.errorsByKeys.userCustomer
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Выберите получателя "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_UserCustomersList, {
                "selected-id": _ctx.orderStore.activeOrder?.userCustomer?.id,
                "is-form-opened-when-empty": true,
                onWasLoaded: _ctx.setDefaultUserCustomer,
                onWasCreated: _ctx.updateUserCustomer,
                onWasSelected: _ctx.updateUserCustomer,
                onWasRemoved: _ctx.removeUserCustomer
              }, null, 8, ["selected-id", "onWasLoaded", "onWasCreated", "onWasSelected", "onWasRemoved"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" Способ доставки "),
              (
              _ctx.orderStore.processBtnWasClicked &&
                _ctx.orderStore.errorsByKeys.deliveryTypeId
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Выберите способ доставки "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_DeliveryTypesPanel, {
                "delivery-types": _ctx.orderStore.deliveryTypes,
                "selected-id": _ctx.orderStore.activeOrder.deliveryTypeId
              }, null, 8, ["delivery-types", "selected-id"]),
              (
              _ctx.orderStore.activeOrder.deliveryTypeId === _ctx.DELIVERY_TYPE.COURIER
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode(" Адрес доставки "),
                      (
                  _ctx.orderStore.processBtnWasClicked &&
                    _ctx.orderStore.errorsByKeys.companyUserDeliveryAddress &&
                    _ctx.isVisibleErrors
                )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Выберите адрес доставки "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_DeliveryAddressesList, {
                      "selected-id": _ctx.orderStore.activeOrder?.companyUserDeliveryAddress?.id,
                      "is-form-opened-when-empty": true,
                      "with-zones": true,
                      onWasLoaded: _ctx.setDefaultDeliveryAddress,
                      onWasUpdated: _ctx.updateDeliveryAddress,
                      onWasSelected: _ctx.selectDeliveryAddress,
                      onWasRemoved: _ctx.removeDeliveryAddress
                    }, null, 8, ["selected-id", "onWasLoaded", "onWasUpdated", "onWasSelected", "onWasRemoved"])
                  ]))
                : _createCommentVNode("", true),
              (
              _ctx.orderStore.activeOrder.deliveryTypeId ===
                _ctx.DELIVERY_TYPE.SELF_PICKUP
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (
                  _ctx.orderStore.processBtnWasClicked &&
                    _ctx.orderStore.errorsByKeys.companyPickupAddress &&
                    _ctx.isVisibleErrors
                )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Выберите адрес самовывоза "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_PickupAddresses, { onWasSelected: _ctx.setVisibilityErrors }, null, 8, ["onWasSelected"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              (_ctx.orderStore.activeOrder)
                ? (_openBlock(), _createBlock(_component_DeliverySettingsForm, {
                    key: 0,
                    "cooking-time": _ctx.orderStore.cookingTime,
                    notes: _ctx.orderStore.activeOrder.notes,
                    "delivery-at": _ctx.orderStore.activeOrder.deliveryAt,
                    "person-count": _ctx.orderStore.activeOrder.personCount,
                    "is-contactless": _ctx.orderStore.activeOrder.isContactless,
                    "confirm-by-phone": _ctx.orderStore.activeOrder.confirmByPhone,
                    "order-placement-options": _ctx.companyStore.activeCompany?.orderPlacementOptions
                  }, null, 8, ["cooking-time", "notes", "delivery-at", "person-count", "is-contactless", "confirm-by-phone", "order-placement-options"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createTextVNode(" Способ оплаты "),
              (
              _ctx.orderStore.processBtnWasClicked &&
                _ctx.orderStore.errorsByKeys.paymentTypeId
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Выберите способ оплаты "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_PaymentTypesPanel, {
                "payments-types": _ctx.orderStore.availablePaymentTypes,
                "selected-payment-type-id": _ctx.orderStore.activeOrder.paymentTypeId
              }, null, 8, ["payments-types", "selected-payment-type-id"]),
              (_ctx.isCertificateWarningVisible)
                ? (_openBlock(), _createBlock(_component_CertificateWarning, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isCashAmountFormVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("input", {
                      value: _ctx.orderStore.activeOrder.cashAmount,
                      class: "base-input base-input--black",
                      type: "number",
                      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.debouncedChangeCashAmountOrder && _ctx.debouncedChangeCashAmountOrder(...args)))
                    }, null, 40, _hoisted_25)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isEmailFormVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", {
                    id: "chequeEmail",
                    class: _normalizeClass(["mo-form-group mo-form-group--line", [
              'mo-form-group',
              { 'mo-form-group--error': _ctx.orderStore.errorsByKeys.chequeEmail },
            ]])
                  }, [
                    _hoisted_27,
                    _createElementVNode("input", {
                      value: _ctx.orderStore.chequeEmail,
                      class: "base-input base-input--black",
                      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.debouncedChangeChequeEmail && _ctx.debouncedChangeChequeEmail(...args)))
                    }, null, 40, _hoisted_28),
                    (_ctx.orderStore.errorsByKeys.chequeEmail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Некорректный email "))
                      : _createCommentVNode("", true)
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("aside", null, [
            _createVNode(_component_SummaryLayout),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("p", null, [
                _createTextVNode(" Нажимая кнопку «Оформить или оплатить», я даю своё согласие на обработку моих персональных данных и передаче их третьим лицам в соответствии с Федеральным законом от 27.07.2006 года №152-ФЗ «О персональных данных», в целях реализации функционала сайта по предоставлению услуг доставки. А также, я даю согласие на получение информационных сообщений, связанных с получением услуг по доставке. Я подтверждаю, что ознакомлен с "),
                (_ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.TERMS_OF_USE])
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.TERMS_OF_USE],
                      target: "_blank"
                    }, "Пользовательским соглашением", 8, _hoisted_32))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Пользовательским соглашением")
                    ], 64)),
                _createTextVNode(" и "),
                (_ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.PRIVACY_POLICY])
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: _ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.PRIVACY_POLICY],
                      target: "_blank"
                    }, "Политикой конфиденциальности", 8, _hoisted_33))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode("Политикой конфиденциальности")
                    ], 64)),
                _createTextVNode(" и "),
                (_ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.CONTRACT_OFFER])
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 4,
                      href: _ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.CONTRACT_OFFER],
                      target: "_blank"
                    }, "Договором публичной оферты", 8, _hoisted_34))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _createTextVNode("Договором публичной оферты")
                    ], 64)),
                _createTextVNode(". ")
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createBlock(_component_EmptyLayout, {
          key: 1,
          title: "Вы пока ничего не добавили в свою корзину"
        })),
    (_ctx.orderStore.invalidOrderErrorsCode)
      ? (_openBlock(), _createBlock(_component_ModalDialog, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_Warning, {
              text: _ctx.INVALID_ORDER_ERRORS.messages[_ctx.orderStore.invalidOrderErrorsCode],
              onClick: _ctx.refreshOrder
            }, null, 8, ["text", "onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}